export const FETCH_TOTAL_CLIENTS = "FETCH_TOTAL_CLIENTS"
export const FETCH_CLIENT_LIST = "FETCH_CLIENT_LIST"
export const FETCH_TOTAL_BOOKINGS = "FETCH_TOTAL_BOOKINGS"